//
// Generated class TipPool
//

/// <reference path="TipPool_ManagedObject.ts" />

class TipPool extends TipPool_ManagedObject
{

}
